import type { StackPreset } from './types';

export const stackPresets: StackPreset[] = [
  {
    id: 't3',
    name: 'T3 Stack',
    description: 'Next.js + tRPC + Prisma + Postgres',
    badges: ['TypeScript', 'Full-stack', 'Type-safe'],
    stack: {
      frontend: 'nextjs',
      backend: 'node-fastify',
      database: 'postgres',
      authProvider: 'better-auth',
      realtime: 'websockets',
      hosting: 'vercel',
    },
  },
  {
    id: 'remix',
    name: 'Remix Stack',
    description: 'React Router + SQLite + better-auth',
    badges: ['TypeScript', 'Edge-ready', 'Lightweight'],
    stack: {
      frontend: 'remix',
      backend: 'node-fastify',
      database: 'sqlite',
      authProvider: 'better-auth',
      realtime: 'sse',
      hosting: 'fly-io',
    },
  },
  {
    id: 'nextjs-fullstack',
    name: 'Next.js Full Stack',
    description: 'Next.js + Prisma + Postgres + Clerk',
    badges: ['TypeScript', 'RSC', 'Managed auth'],
    stack: {
      frontend: 'nextjs',
      backend: 'node-fastify',
      database: 'postgres',
      authProvider: 'auth0-clerk',
      realtime: 'polling',
      hosting: 'vercel',
    },
  },
  {
    id: 'mern',
    name: 'MERN Stack',
    description: 'React SPA + Express + MongoDB',
    badges: ['JavaScript', 'NoSQL', 'Classic'],
    stack: {
      frontend: 'react-spa',
      backend: 'node-express',
      database: 'mongodb',
      authProvider: 'passport',
      realtime: 'polling',
      hosting: 'render',
    },
  },
  {
    id: 'rails',
    name: 'Rails Stack',
    description: 'Ruby on Rails + Hotwire + Postgres',
    badges: ['Ruby', 'Convention', 'Batteries-included'],
    stack: {
      frontend: 'remix',
      backend: 'rails',
      database: 'postgres',
      authProvider: 'devise',
      realtime: 'sse',
      hosting: 'fly-io',
    },
  },
  {
    id: 'fastapi',
    name: 'FastAPI Stack',
    description: 'FastAPI + React SPA + Postgres',
    badges: ['Python', 'Async', 'High performance'],
    stack: {
      frontend: 'react-spa',
      backend: 'python-fastapi',
      database: 'postgres',
      authProvider: 'better-auth',
      realtime: 'websockets',
      hosting: 'railway',
    },
  },
  {
    id: 'sveltekit',
    name: 'SvelteKit',
    description: 'SvelteKit + Drizzle + Postgres',
    badges: ['TypeScript', 'Lightweight', 'Full-stack'],
    stack: {
      frontend: 'sveltekit',
      backend: 'node-fastify',
      database: 'postgres',
      authProvider: 'better-auth',
      realtime: 'sse',
      hosting: 'vercel',
    },
  },
  {
    id: 'supabase',
    name: 'Supabase Stack',
    description: 'Next.js + Supabase (Postgres + Auth) + Vercel',
    badges: ['TypeScript', 'BaaS', 'Realtime'],
    stack: {
      frontend: 'nextjs',
      backend: 'node-fastify',
      database: 'postgres',
      authProvider: 'auth0-clerk',
      realtime: 'supabase-realtime',
      hosting: 'vercel',
    },
  },
  {
    id: 'indie-hacker',
    name: 'Indie Hacker',
    description:
      'Remix + SQLite + better-auth + Railway — ship fast, stay lean',
    badges: ['TypeScript', 'Solo-friendly', 'Low cost'],
    stack: {
      frontend: 'remix',
      backend: 'node-express',
      database: 'sqlite',
      authProvider: 'better-auth',
      realtime: 'polling',
      hosting: 'railway',
    },
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Next.js + Postgres + Auth0/Clerk + AWS — compliance-ready',
    badges: ['TypeScript', 'SOC 2', 'Scalable'],
    stack: {
      frontend: 'nextjs',
      backend: 'node-fastify',
      database: 'postgres',
      authProvider: 'auth0-clerk',
      realtime: 'pusher-ably',
      hosting: 'aws',
    },
  },
];
